<template>
  <main class="relative min-h-screen">
    <img src="../../assets/images/login-Bg.svg" alt="" class="absolute top-0 left-0 w-full h-full object-cover -z-10">
    <div
      class="relative tablet:absolute z-10 top-0 right-0 tablet:py-2 mobile:overflow-y-auto tablet:!h-[100vh] mobile:justify-start tablet:justify-center desktop:justify-start largeDesktop:!h-screen mobile:px-3 tablet:px-20 desktop:px-16 largeDesktop:px-12 flex flex-col items-center justify-center mobile:w-full desktop:w-2/5 largeDesktop:1/3 bg-opacity-80 bg-black-100">
      <div class="mobile:mt-10 tablet:mt-0 flex items-center justify-start w-full mobile:gap-2 tablet:gap-3">
        <img src="../../assets/images/fyxifyLogo.png"
          class="mobile:w-12 mobile:h-12 laptop:w-18 laptop:h-18 desktop:w-18 desktop:h-18 largeDesktop:w-20 largeDesktop:h-20 object-cover"
          alt="fyxify Logo">
        <h4 class="m-0 font-roboto mobile:text-lg tablet:text-xl desktop:2xl text-white">Create New Account</h4>
      </div>
      <div class="flex items-center justify-start mobile:my-2 tablet:my-4">
        <div
          class="relative rounded-full overflow-hidden mobile:w-20 mobile:h-20 tablet:w-24 tablet:h-24 shadow-[0px_4px_10px_0px_#00000040] bg-white cursor-pointer"
          @click="triggerFileUpload">
          <img :src="imageSrc || require('@/assets/images/register-camera-icon.png')" alt="Profile"
            class="object-cover w-full h-full" />
          <input type="file" accept="image/*" ref="fileInput" @change="handleFileChange" class="hidden" />
        </div>
      </div>
      <div class="mobile:mb-10 tablet:mt-0 grid grid-cols-2 w-full mobile:gap-4 desktop:!gap-4 largeDesktop:gap-4">
        <div>
          <label for="firstName" class="pb-1 mobile:text-[14px] tablet:text-[15px] text-white">First Name: <span
              class="text-red-600">*</span></label>
          <inputComponent ref="firstNameRef" v-model="first_name" name="firstName" required
            placeholder="Enter First Name" />
        </div>
        <div>
          <label for="lastName" class="pb-1 mobile:text-[14px] tablet:text-[15px] text-white">Last Name: <span
              class="text-red-600">*</span></label>
          <inputComponent ref="lastNameRef" v-model="last_name" name="lastName" required
            placeholder="Enter Last Name" />
        </div>
        <div>
          <label for="email" class="pb-1 mobile:text-[14px] tablet:text-[15px] text-white">Email: <span
              class="text-red-600">*</span></label>
          <inputComponent ref="emailRef" v-model="email" name="email" required :regex="$constants.EMAIL_REGEX"
            error-message="Please enter a valid email address" placeholder="Enter Email" />
        </div>
        <div>
          <label for="phoneNumber" class="pb-1 mobile:text-[14px] tablet:text-[15px] text-white">Phone: <span
              class="text-red-600">*</span></label>
          <inputComponent ref="phoneRef" v-model="phone" name="phone" required mask="(###) ###-####"
            placeholder="Enter Number" error-message="Invalid phone number" />
        </div>
        <div>
          <label for="password" class="pb-1 mobile:text-[14px] tablet:text-[15px] text-white">Password: <span
              class="text-red-600">*</span></label>
          <inputComponent v-model="password" ref="passwordRef" name="password" type="password" required
            :regex="$constants.PASSWORD_REGEX"
            error-message="Minimum 8 characters with uppercase, number & symbol. Emojis are not allowed." placeholder="Enter Password" />
        </div>
        <div>
          <label for="confirmPhoneNumber" class="pb-1 mobile:text-[14px] tablet:text-[15px] text-white">Confirm
            Password: <span class="text-red-600">*</span></label>
          <inputComponent v-model="confirmPassword" ref="confirmPasswordRef" name="confirmPassword" type="password"
            required :confirmWith="password" placeholder="Enter Password"
            error-message="Passwords do not match" />
        </div>
        <div class="col-span-2">
          <label for="companyReferral" class="pb-1 mobile:text-[14px] tablet:text-[15px] text-white">
            Company Referral<span class="text-xs">(if you were referred by a company)</span>:
          </label>
          <div class="relative">
            <inputComponent ref="companyReferral" v-model="company_referal" name="companyReferral" :disabled="loading"
              placeholder="Company Referral" @input="handleInput" />
            <div v-if="loading" class="absolute right-0 top-0 flex items-center justify-center h-full px-2">
              <svg class="animate-spin h-6 w-6 text-red-500" xmlns="http://www.w3.org/2000/svg" fill="none"
                viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
              </svg>
            </div>
          </div>
          <p v-if="isAppiCAlled && !isRefferalFound" class="text-red-500 text-xs mt-1 mb-0">{{ "Invalid Refferal Code"
          }}</p>
        </div>
        <div class="col-span-2 border-2 rounded-full w-max mx-auto mobile:p-1 tablet:p-1 desktop:mt-2 border-[#FE5000]">
          <p class="m-0 mobile:text-sm tablet:text-base text-[#FE5000]">OR</p>
        </div>
        <div class="col-span-2">
          <label for="companyReferral" class="pb-1 mobile:text-[14px] tablet:text-[15px] text-white">Company Name:
            <span class="text-red-600">*</span></label>
          <div class="relative">
            <inputComponent ref="companyName" v-model="company_name" name="companyName" required
              :disabled="isRefferalFound" placeholder="Company Name" />
          </div>
        </div>
        <div class="col-span-2">
          <label for="companyReferral" class="pb-1 mobile:text-[14px] tablet:text-[15px] text-white">Company
            Address:<span class="text-red-600">*</span></label>
          <div class="relative">
            <GoogleAutoComplete v-if="!isRefferalFound" v-model="company_address" placeholder="Address"
              :reset="resetAddress" @place-selected="handlePlace" @address-reset="selectedAddress = null"
              :input-class="'w-full mobile:p-1.5 largeDesktop:p-2 border border-gray-600 text-gray-600 outline-none text-sm'" />
            <inputComponent v-else v-model="company_address" :disabled="isRefferalFound" />
          </div>
          <p v-if="selectedAddress == null && !isRefferalFound && isValidate" class="text-red-500 text-xs mt-1 mb-0">{{
            "Please select address." }}</p>
        </div>
        
    
        <div class="col-span-2">
          <RecaptchaBox @verified="recaptchaVerified" ref="recaptchaRef" />
        </div>
        <div class="col-span-2">

          <p class="m-0 text-sm text-justify text-white">By clicking "Submit", you agree to the portyl® <a
              :href="icaUrl ? icaUrl : ''" target="_blank"
              class="cursor-pointer text-sm no-underline text-[#FE5000]">Contractor Agreement </a>and<a
              :href="privacyUrl ? privacyUrl : ''" target="_blank"
              class="cursor-pointer text-sm no-underline text-[#FE5000]"> Privacy Policy </a>
            </p>
            <p class="m-0 text-sm text-justify text-white mt-2">You may receive text messages from fyxify related to your account and verification (e.g., 2FA codes or service notifications)</p> 

        </div>

        <div class="col-span-2">
          <div class="flex desktop:items-start laptop:items-center mobile:items-start">
                <label class="flex items-start cursor-pointer mt-2">
                    <input type="checkbox" v-model="checkbox" class="hidden peer" />
                    <span
                        class="min-w-7 min-h-7 flex items-center justify-center border-[1px] !border-[#ccc] bg-white rounded-md transition">
                        <svg v-if="checkbox == true" class="w-6 h-6 text-blue-600" fill="none" stroke="currentColor"
                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 20 20">
                            <path d="M5 10.5 8.5 14 15 7.5" />
                        </svg>
                    </span>
                </label>
                <span class="ml-2 text-sm font-normal text-white text-justify">I would like to receive promotional offers and relevant information from fyxify via text message. Message and data rates may apply.</span>
            </div>
        </div>

        <div class="col-span-2">
          <button @click="submitClicked" :disabled="loading"
            class="mobile:px-8 mobile:py-1.5 largeDesktop:px-10 largeDesktop:py-1.5 mobile:mt-3 tablet:mt-5 rounded-full mobile:text-base largeDesktop:text-xl mx-auto block cursor-pointer bg-gradient-to-r from-blue-600 to-sky-600 text-white"
            type="submit">Submit</button>
          <p class="mt-4 mb-0 text-center text-white">Aready have an account? <span @click="loginClicked()"
              class="cursor-pointer text-[#FE5000]">Login</span> </p>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import inputComponent from '../../components/partialComponent/inputComponent.vue';
import GoogleAutoComplete from '../../components/partialComponent/GoogleAutoComplete.vue';
import RecaptchaBox from '../../components/partialComponent/recaptchaBox.vue'
import { useToast } from "vue-toastification";
import { mapActions, mapGetters } from "vuex";
const toast = useToast();
export default {
  components: {
    inputComponent,
    GoogleAutoComplete,
    RecaptchaBox
  },
  data() {
    return {
    checkbox: false,
      imageSrc: null,
      imageFile: null,
      phone: null,
      first_name: null,
      last_name: null,
      email: null,
      selectedAddress: null,
      company_address: null,
      company_referal: '',
      company_name: null,
      password: null,
      confirmPassword: null,
      loading: false,
      debounceTimer: null,
      isRefferalFound: false,
      companyRefferalModel: null,
      isAppiCAlled: false,
      isValidate: false,
      recaptchaToken: null,
      icaUrl: null,
      privacyUrl: null
    };
  },


  computed: {
    ...mapGetters([
      "companyReferalCode",
      "userObject",
      "bootMeUpData"
    ]),


  },

  watch: {
    companyReferalCode: function (data) {
      this.loading = false
      this.isAppiCAlled = true
      if (this.companyReferalCode.status == true) {
        this.isRefferalFound = true
        this.companyRefferalModel = this.companyReferalCode.body
        this.company_name = this.companyRefferalModel.company_name
        this.company_address = this.companyRefferalModel.company_address
      } else {
        this.companyRefferalModel = null
        this.isRefferalFound = false
        this.selectedAddress = null
        this.company_address = null
        this.company_name = null
      }
    },

    bootMeUpData: function () {
      this.icaUrl = this.bootMeUpData.static_pages['setting.application.static_pages.ica']
      this.privacyUrl = this.bootMeUpData.static_pages['setting.application.static_pages.privacy_policy']
    },

    userObject: function () {

      if (this.userObject != 'undefined') {
        if (this.userObject.user.email_verification == '0') {
          this.saveState()
          this.$router.replace({
            name: 'verification'
          })
        }
      }
    },
  },

  mounted() {
    // const savedData = localStorage.getItem('registerFormData');
    // if (savedData) {
    //   const formData = JSON.parse(savedData);
    //   Object.assign(this, formData);
    // }
    this.getBootMeData({})
    document.body.style.position = '';
    document.body.style.overflow = '';
    document.body.classList.remove('modal-open');
  },

  beforeUnmount() {
    document.body.style.position = '';
    document.body.style.overflow = '';
  },

  methods: {

    ...mapActions([
      "checkCompanyReferalCode",
      "userRegister",
      "getBootMeData",
    ]),

    triggerFileUpload() {
      this.$refs.fileInput.click();
    },
    handleFileChange(event) {
      this.imageFile = event.target.files[0];

      if (this.imageFile) {
        const reader = new FileReader();
        reader.onload = e => {
          this.imageSrc = e.target.result;
        };
        reader.readAsDataURL(this.imageFile);
      }
    },

    resetAddress() {
      this.selectedAddress = null
    },

    handlePlace(data) {
      this.selectedAddress = data
    },

    handleInput() {
      clearTimeout(this.debounceTimer);
      // Start new debounce timer
      this.debounceTimer = setTimeout(() => {
        this.checkRefferal()

      }, 1000); // 1200ms delay
    },

    checkRefferal() {
      if (!this.$helper.isEmpty(this.company_referal) || this.company_referal.trim().length > 0) {
        this.loading = true
        this.checkCompanyReferalCode({
          "company_referral": this.company_referal
        });
      } else {
        this.isAppiCAlled = false
      }
    },

    recaptchaVerified(token) {
      this.recaptchaToken = token;
    },


    submitClicked() {

      const refsToValidate = [
        this.$refs.firstNameRef,
        this.$refs.lastNameRef,
        this.$refs.emailRef,
        this.$refs.phoneRef,
        this.$refs.passwordRef,
        this.$refs.confirmPasswordRef,
        this.$refs.companyName
      ];
      this.isValidate = true

      let firstInvalidRef = null;

      // Validate each ref
      for (const ref of refsToValidate) {
        if (ref?.validate?.()) {
          if (!firstInvalidRef) firstInvalidRef = ref;
        }
      }

      const addressProvided = !!this.selectedAddress;

      if (firstInvalidRef) {
        // Scroll to and focus the first invalid field
        firstInvalidRef.$el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        const inputEl = firstInvalidRef.$el.querySelector('input');
        inputEl?.focus();
        return;
      }

      if (this.isAppiCAlled && !this.isRefferalFound) {
        return
      }

      if (!this.isAppiCAlled && !addressProvided) {
        return
      }

      if (!this.recaptchaToken) {
        toast.error("You must verify the reCAPTCHA before continuing.");
        return;
      }

      this.callUserRegister()


    },

    callUserRegister() {

      let formData = new FormData()
      formData.append("first_name", this.first_name)
      formData.append("last_name", this.last_name)
      formData.append("password", this.password.trim())
      formData.append("password_confirmation", this.confirmPassword)
      formData.append("email", this.email.trim())
      formData.append("phone", this.phone)
      formData.append("captcha_token", this.recaptchaToken)
      formData.append("timestamp", (new Date()).getTime())


      if (this.isRefferalFound) {
        formData.append("company_referral", this.company_referal)
        formData.append("company_name", this.company_name)
        formData.append("company_address", this.company_address)
        formData.append("company_address_lat", this.companyRefferalModel.company_address_lat)
        formData.append("company_address_lng", this.companyRefferalModel.company_address_lng)
      } else {
        formData.append("company_name", this.company_name)
        formData.append("company_address", this.selectedAddress.formatted_address)
        formData.append("company_address_lat", this.selectedAddress.geometry?.location?.lat())
        formData.append("company_address_lng", this.selectedAddress.geometry?.location?.lng())
      }

      if (this.imageFile) {
        formData.append("image", this.imageFile)
      }
      this.$refs.recaptchaRef.resetCall()
      this.userRegister(formData)

    },

    saveState() {
      const formData = {
        imageSrc: this.imageSrc,
        imageFile: this.imageFile,
        phone: this.phone,
        first_name: this.first_name,
        last_name: this.last_name,
        email: this.email.trim(),
        selectedAddress: this.selectedAddress,
        company_address: this.company_address,
        company_referal: this.company_referal,
        company_name: this.company_name,
        password: this.password,
        confirmPassword: this.confirmPassword,
        isRefferalFound: this.isRefferalFound,
        companyRefferalModel: this.companyRefferalModel
      };
      localStorage.setItem('registerFormData', JSON.stringify(formData));
    },

    loginClicked() {
      localStorage.removeItem('registerFormData')
      this.$router.go(-1)
    }
  },

};
</script>
